import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=675dbc62&"
import script from "./Media.vue?vue&type=script&lang=js&"
export * from "./Media.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports